import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import Modal from "@material-ui/core/Modal";
import { makeStyles } from "@material-ui/core/styles";
import { forwardRef } from "react";
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import ViewColumn from "@material-ui/icons/ViewColumn";
import Search from "@material-ui/icons/Search";
import RefreshIcon from "@mui/icons-material/Refresh";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { DateRangePicker } from "react-date-range";
import { addDays } from "date-fns";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import moment from "moment";
import LoadingSpinner from "./LoadingSpinner";
// import CloseIcon from "@material-ui/icons/Close"; // Import the Close icon
import CancelIcon from '@mui/icons-material/Cancel';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import FileOpenIcon from '@mui/icons-material/FileOpen';// Define the getModalStyle function

const getModalStyle = () => {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
};

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    position: "absolute",
    width: 1200,
    height: 600,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  closeButton: {
    alignSelf: "flex-end",
    cursor: "pointer",
    padding: "10px",
    fontSize: "16px",
    // color: "#fff",
    // backgroundColor: "#e74c3c",
    border: "none",
    borderRadius: "4px",
    // boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    // transition: "background-color 0.3s, transform 0.2s",
    marginBottom: "10px",
  },
  closeButtonHover: {
    // backgroundColor: "#c0392b",
    transform: "scale(1.05)",
  },
}));

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

function AuditedSalesReport() {
  const classes = useStyles();
  const [posts, setPosts] = useState([]);
  const [closeIsHovered, setCloseIsHovered] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);
  const [iframeUrl, setIframeUrl] = React.useState("");
  const [viewAs, setViewAs] = React.useState("all");
  const [viewDaterangeBoolean, setViewDaterangeBoolean] = React.useState(false);
  const [selectedDateRange, setSelectedDateRange] = React.useState([
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ]);

  const currentDate = new Date().getFullYear() + '-' +
    (new Date().getMonth() + 1).toString().padStart(2, '0') + '-' +
    new Date().getDate().toString().padStart(2, '0');

  useEffect(() => {
    setIsLoading(true);
    fetchPosts();
  }, []);

  const fetchPosts = async (sdate=currentDate, edate=currentDate) => {
    try {
      let response;
      const baseUrl = "https://rms.healtheesystems.com:9443/rms-cctools-0.0.1-SNAPSHOT/rms_sales_data";
      if (!sdate || !edate) {
        response = await fetch(`${baseUrl}?flow=processor`);
      } else {
        response = await fetch(
          `${baseUrl}/date?flow=processor&startDate=${sdate}&endDate=${edate}`
        );
      }
      const postData = await response.json();
      setPosts(postData);
    } catch (error) {
      console.error("Error fetching posts:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpen = (url) => {
    setIframeUrl(url);
    setOpen(true);
  };

  const onCloseMouseEnter = () => {
    setCloseIsHovered(true);
  };
  const onCloseMouseLeave = () => {
    setCloseIsHovered(false);
  };

  const handleClose = () => setOpen(false);

  const handleViewChange = (event) => {
    setViewAs(event.target.value);
    if (event.target.value === "all") {
      setViewDaterangeBoolean(false);
      fetchPosts();
    } else {
      setViewDaterangeBoolean(true);
    }
  };

  const handleSelectDateRange = (item) => {
    setSelectedDateRange([item.selection]);
    const newSDate = moment(item.selection.startDate).format("YYYY-MM-DD");
    const newEDate = moment(item.selection.endDate).format("YYYY-MM-DD");
    fetchPosts(newSDate, newEDate);
  };

  const handleButtonClick = (rowData) => {
    const { phoneNumber, processorAgentLogin, serviceId, station, dnis,Id } = rowData.customerData;
    const url = `https://rms.healtheesystems.com:9443/Script/supervisorProcessorFom.html?phone=${phoneNumber}&login=${processorAgentLogin}&serviceId=7031&station=${station}&dnis=${dnis}&recordId=${Id}`;
    handleOpen(url);
  };

  const columns = [
    {title: "ID", field: "customerData.id" },
    { title: "Customer name", field: "customerData.username" },
    { title: "Phone No", field: "customerData.phoneNumber" },
    { title: "Agent name", field: "customerData.applicant.agentName" },
    { title: "Campaign name", field: "serviceName" },
    { title: "Call Date", field: "customerData.rdate" },
    { title: "City", field: "customerData.city" },
    { title: "State", field: "customerData.state" },
    { title: "Origin", field: "customerData.origin" },
    { title: "Qa Agent Name", field: "customerData.qaAgentName" },
    { title: "Qa Login", field: "customerData.qaAgentLogin" },
    { title: "Qa Call Date", field: "customerData.qaRdate" },
    { title: "Application ID", field: "customerData.applicationId" },
    { title: "Processed By", field: "customerData.processorAgentName" },
    { title: "MarketPlace Email", field: "customerData.marketplaceEmail" },
    {
      title: "Actions",
      field: "actions",
      render: rowData => (
        <button
          onClick={() => handleButtonClick(rowData)}
          style={{
            padding: "10px 20px",
            cursor: "pointer",
            border: "none",
            borderRadius: "5px",
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = "scale(1.05)";
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = "scale(1)";
          }}
        >
          <FileOpenIcon />
        </button>
      )
    },
  ];

  return (
    <div className="App wrapper" id="agentlogview">
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <FormControl>
            <RadioGroup
              row
              aria-labelledby="view-as-label"
              name="view-as-group"
              value={viewAs}
              onChange={handleViewChange}
            >
              <FormControlLabel value="all" control={<Radio />} label="View All" />
              <FormControlLabel value="date_range" control={<Radio />} label="View by Date" />
            </RadioGroup>
          </FormControl>
          <br />
          <br />
          {viewDaterangeBoolean && (
            <DateRangePicker
              onChange={handleSelectDateRange}
              moveRangeOnFirstSelection={false}
              editableDateInputs={true}
              ranges={selectedDateRange}
            />
          )}
          <MaterialTable
            title="Audited Sales Report"
            icons={tableIcons}
            columns={columns}
            data={posts}
            localization={{
              toolbar: {
                exportCSVName: "Export as Excel",
                exportPDFName: "Export as PDF",
              },
            }}
            options={{
              search: true,
              exportButton: {
                csv: true,
                pdf: true,
              },
              toolbar: true,
              headerStyle: {
                backgroundColor: "#EEE",
                fontWeight: "bold",
              },
              titleStyle: {
                backgroundColor: "#EEE",
              },
              pageSizeOptions: [10, 50, 100, 200, 300, 400, 500, 1000],
            }}
            actions={[
              {
                icon: () => <RefreshIcon />,
                tooltip: "Refresh Data",
                isFreeAction: true,
                onClick: () => {
                  setIsLoading(true);
                  fetchPosts();
                },
              },
            ]}
          />
        </>
      )}

      <Modal
        aria-labelledby="iframe-modal-title"
        aria-describedby="iframe-modal-description"
        open={open}
        onClose={handleClose}
        className={classes.modal}
      >
        <div className={classes.paper}>
          <button
            onClick={handleClose}
            className={classes.closeButton}
            // onMouseEnter={(e) => e.target.classList.add(classes.closeButtonHover)}
            // // onMouseEnter={(e) => e.target.classList.add(<HighlightOffIcon />)}
            // onMouseLeave={(e) => e.target.classList.remove(classes.closeButtonHover)}
            onMouseEnter={() => setCloseIsHovered(!closeIsHovered)}
            onMouseLeave={() => setCloseIsHovered(!closeIsHovered)}
          >
            {/* <HighlightOffIcon /> */}
            {closeIsHovered ? (
              <HighlightOffIcon
              // style={{ color: "grey", fontSize: 20, marginRight: 10 }}
              />
            ) : (
              <CancelIcon
              // style={{ color: "grey", fontSize: 20, marginRight: 10 }}
              />
            )}
          </button>
          <iframe
            src={iframeUrl}
            style={{ width: "100%", height: "100%", border: "none" }}
            title="Form Iframe"
          />
        </div>
      </Modal>
    </div>
  );
}

export default AuditedSalesReport;
